// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-member__valid-label[data-v-240d2a60]{font-weight:bold}.table-member__valid-label_success[data-v-240d2a60]{color:#51a251}.table-member__valid-label_warning[data-v-240d2a60]{color:#e7b645}.table-member__valid-label_error[data-v-240d2a60]{color:#cf583a}.table-member__action-icon[data-v-240d2a60]{font-size:21px;margin:3px}\n", ""]);
// Exports
module.exports = exports;
